import type { TCountries } from "countries";

const getDifferenceInDays = (date1: Date, date2: Date) => {
    // Calculating the time difference of two dates
    const timeDifference = date2.getTime() - date1.getTime();

    // Calculating the no. of days between two dates
    const daysDifference = Math.round(timeDifference / (1000 * 3600 * 24));

    return daysDifference;
};

export const getDifferenceInMonths = (date2: Date, date1: Date) => {
    const firstDate = typeof date1 !== "object" ? new Date(date1) : date1;
    const secondDate = typeof date2 !== "object" ? new Date(date2) : date2;

    // Calculates the difference in milliseconds between the two dates.
    let difference = (secondDate.getTime() - firstDate.getTime()) / 1000;
    // Converts the difference from milliseconds to months by dividing it by the number of milliseconds in an hour, a day, a week, and approximately 4 weeks in a month.
    difference /= 60 * 60 * 24 * 7 * 4;
    // Round the result to the nearest integer using Math.round().
    return Math.abs(Math.round(difference));
};

/**
 * Calculates number of payments within lifespan of transfer term.
 * @param paymentDelay Number of days between two payments.
 * @param startDate Start of the contract.
 * @param dueDate End of the contract
 * @returns (int) number of payments
 */
export const getNumberOfPayments = (paymentDelay: number, startDate: string, dueDate: string) => {
    // Get total number of days between the two dates:
    const totalDays = getDifferenceInDays(new Date(startDate), new Date(dueDate));

    return Math.round(totalDays / paymentDelay);
};

export const getListOfCountries = (countriesCodes: string[], countries: TCountries[]) => {
    const countriesNames = countriesCodes.map((code) => {
        const country = countries.find((item) => item.code === code);
        return country?.name ?? "";
    });

    return countriesNames.join(", ");
};
